import React from 'react';
import Select, { ValueType } from 'react-select';
import { OnChange } from 'types/OnChange';
import { OptionsType } from 'types/OptionsType';

import { PropertyDefinition } from '../../../types/PropertyDefinition';

type Props = {
  propertyDefinition?: ValueType<OptionsType, false>;
  propertyDefinitions: Array<PropertyDefinition>;
  onChange: OnChange;
  loading: boolean;
};

const PropertyDefinitionSelector: React.FC<Props> = ({
  propertyDefinition,
  propertyDefinitions,
  loading,
  onChange,
}: Props) => {
  const styles = {
    control: (base: any) => ({
      ...base,
      fontSize: '80%',
      minHeight: null,
    }),
    menu: (base: any) => ({
      ...base,
      fontSize: '80%',
    }),
    indicatorsContainer: (base: any) => ({
      ...base,
      padding: 0,
      fontSize: '50%',
    }),
  };

  return (
    <Select
      options={propertyDefinitions.map(({ id, label }) => ({ value: id, label }))}
      onChange={onChange}
      isClearable={true}
      isLoading={loading}
      value={propertyDefinition}
      styles={styles}
    />
  );
};

export default PropertyDefinitionSelector;
